import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=1018ac30"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1018ac30')) {
      api.createRecord('1018ac30', component.options)
    } else {
      api.reload('1018ac30', component.options)
    }
    module.hot.accept("./SaveIcon.vue?vue&type=template&id=1018ac30", function () {
      api.rerender('1018ac30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/SaveIcon.vue"
export default component.exports